import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import Paper from '@material-ui/core/Paper';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Typography from '@material-ui/core/Typography';
import Avatar from "@material-ui/core/Avatar";
import CircularProgress from '@material-ui/core/CircularProgress';
import Moment from 'moment';

Moment.locale('ja');

const styles = theme => ({
    list_chat: {
        width: "100%",
    },
    paper_leftCallout: {
        position: "relative",
        display: "inline-block",
        margin: "0.5em 3em 0.5em 15px",
        padding: "7px 10px",
        minWidth: "120px",
        maxWidth: "280px",
        color: "black",
        backgroundColor: "#e0edff",
    },
    paper_rightCallout: {
        display: "inline-block",
        margin: "0.5em 15px 0.5em 15px",
        padding: "7px 10px",
        position: "relative",
        minWidth: "120px",
        maxWidth: "280px",
        backgroundColor: "#40C005",
        color: "black"
    },
    paper_centerCallout: {
        position: "relative",
        display: "inline-block",
        margin: "0 auto",
        padding: "7px 10px",
        width: "400px",
        textAlign: "center",
        minWidth: "120px",
        maxWidth: "100%",
        backgroundColor: "#5D6A7B",
    },
    image_cardMedia: {
        width: "300px",
        height: "auto"
    },
    message_content: {

    },
    avatarColor: {
        color: "white",
        backgroundColor : "indianred"
    },
    avatarColorSystem: {
        color: "white",
        //backgroundColor : "#4DABDF"
        backgroundColor : "#4EDE80"
    },
    admin_avatar: {
    },
    template_message: {
        color: "white",
        fontSize: "12px"
    },
    admin_text: {
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    list_item_text_messageView: {
        fontSize: "12px",
        wordWrap: "break-word",
        whiteSpace: "pre-wrap"
    },
    listItemMargine: {
        margin:"0"
    },
    loading_position: {
        textAlign: "left"
    },
    listItem_avatar_and_paper_area:{
        display:"flex"
    },
    sending_time_area_user:{
        position: "absolute",
        left: "76px",
    },
    sending_time_area_supporter:{
        position: "absolute",
        right: "76px",
    },
    listItem_area:{
        display:"block",
        paddingTop: "11px",
        paddingBottom: "11px"
    },
    sending_time_font:{
        fontSize:"10px",
        color:"white",
        position:"relative"
    },
    avaterItem: {
        minWidth: '30px'
    }

});

class MessageView extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        // API読み込み時ローディング画面を表示するためのフラグ
        this.isLoading = false;
        // this.tick = this.tick.bind(this);
    }
    // _isMounted = false;

    setloading(loadingFlag) {
        this.isLoading = loadingFlag
    }

    //-----------------------------------------------------------------
    //                  ライフサイクルブロック
    //-----------------------------------------------------------------

    

    // コンポーネントがマウントされた直後に実行
    componentDidMount() {
        

    }
    // コンポーネントがマウントされていない時
    componentWillUnmount() {
    }

    // static getDerivedStateFromProps() {
    //     return null;
    // }

    //-----------------------------------------------------------------
    // コンポーネントがマウントされた直後に実行
    //-----------------------------------------------------------------

    // レンダリング後にHook
    componentDidUpdate() {
        // this.setloading(false);
        // 前回と同じメッセージ数か
        if (this.MessageCount === this.props.messagesArray.length) {
            return
        }
        // メッセージが受信されているか
        // if (this.props.messagesArray.length === 0) {
        //     return
        // }
        // スクロール移動
        const node = ReactDOM.findDOMNode(this.messagesEnd);
        node.scrollIntoView({ block: "end", inline: "nearest" });
        // 前回のメッセージ数を確保
        this.MessageCount = this.props.messagesArray.length
        // console.log(`DidUpdate : ${this.props.messagesArray.length}`)
    }
    //-----------------------------------------------------------------
    // 表示ブロック
    //-----------------------------------------------------------------
    render() {
        const { classes, messagesArray } = this.props;
        // const { } = this.state;
        //true or falseで作ると機能拡張のに困るため文字列判定
        return (

            // -------------------------
            // チャットを表示するエリア
            // -------------------------
            <div className={classes.message_content}>
                <List className={classes.list_chat}>
                    {messagesArray.map((data, key) => (
                        // 送信者がユーザなら白
                        // {/* 送信者がユーザでテキストの場合 */}
                        <React.Fragment key={key}>
                            {data.senderFlag === "1" && data.messageType === "1" && (

                                    <ListItem className={classes.listItem_area}>
                                        <div className={classes.listItem_avatar_and_paper_area}>
                                            <ListItemAvatar className={classes.avaterItem}>
                                                <Avatar className={classes.avatarColor}>
                                                    {data.senderFullName != null ? data.senderFullName[0] : ''}
                                                </Avatar>
                                            </ListItemAvatar>

                                            <Paper
                                                className={classes.paper_leftCallout}
                                                elevation='2'
                                            >

                                                <ListItemText
                                                    className={classes.listItemMargine}
                                                    primary={
                                                        <React.Fragment>
                                                            <Typography variant="body2" className={classes.list_item_text_messageView}>
                                                                {data.sendMessage}
                                                            </Typography>
                                                            {/* <Typography className={classes.list_item_text_messageView}>
                                                                {data.sendingTime}
                                                            </Typography> */}
                                                        </React.Fragment>
                                                    }
                                                />
                                            </Paper>
                                        </div>

                                        <div className={classes.sending_time_area_user}>
                                            <Typography variant="body2" className={classes.sending_time_font}>
                                                {data.sendingTime}
                                            </Typography>
                                        </div>

                                    </ListItem>
                            )}

                            {/* 送信者がユーザで定型文の回答の場合 */}
                            {/* {data.senderFlag === "1" && data.messageType === "4" && (

                                <ListItem alignItems="flex-start">
                                    <Paper className={classes.paper_centerCallout}>
                                        <ListItemText

                                            primary={
                                                <Typography type="body2" style={{ color: 'white' }}>
                                                    {data.sendMessage}
                                                    <p>{data.sendingTime}</p>
                                                </Typography>
                                            }
                                        />
                                    </Paper>
                                </ListItem>

                            )} */}
                            {/* 送信者が管理者でテキストの場合 */}
                            {data.senderFlag === "2" && data.messageType === "1" && (
                                // 送信者が管理者なら緑
                                <ListItem className={classes.listItem_area}>
                                    <div className={classes.listItem_avatar_and_paper_area + " " + classes.admin_text}>
                                        <Paper 
                                            className={classes.paper_rightCallout}
                                            elevation='2'>
                                            {/* {this.state.displayName}  */}
                                            <ListItemText
                                                className={classes.listItemMargine}
                                                primary={
                                                    <React.Fragment>
                                                        <Typography variant="body2" className={classes.list_item_text_messageView}>
                                                            {data.sendMessage}
                                                        </Typography>
                                                    </React.Fragment>
                                                }
                                            />
                                        </Paper>
                                        <ListItemAvatar className={classes.avaterItem}>
                                            <Avatar className={classes.avatarColor + " " + classes.admin_avatar}>
                                                {data.senderFullName != null ? data.senderFullName[0] : ''}
                                            </Avatar>
                                        </ListItemAvatar>
                                    </div>
                                    <div className={classes.sending_time_area_supporter}>
                                        <Typography variant="body2" className={classes.sending_time_font}>
                                            {data.sendingTime}
                                        </Typography>
                                    </div>

                                </ListItem>
                            )}
                            {/* 送信者がシステムでテキストの場合 */}
                            {/* 送信者が管理者でテキストの場合 */}
                            {data.senderFlag === "3" && data.messageType === "1" && (
                                // 送信者が管理者なら緑
                                <ListItem className={classes.listItem_area}>
                                    <div className={classes.listItem_avatar_and_paper_area + " " + classes.admin_text}>
                                        <Paper
                                            className={classes.paper_rightCallout}
                                            elevation='2'>
                                            {/* {this.state.displayName}  */}
                                            <ListItemText
                                                className={classes.listItemMargine}
                                                primary={
                                                    <React.Fragment>
                                                        <Typography variant="body2" className={classes.list_item_text_messageView}>
                                                            {data.sendMessage}
                                                        </Typography>
                                                    </React.Fragment>
                                                }
                                            />
                                        </Paper>
                                        <ListItemAvatar className={classes.avaterItem}>
                                            <Avatar className={classes.avatarColorSystem + " " + classes.admin_avatar}>
                                                {data.senderFullName != null ? data.senderFullName[0] : ''}
                                            </Avatar>
                                        </ListItemAvatar>
                                    </div>
                                    <div className={classes.sending_time_area_supporter}>
                                        <Typography variant="body2" className={classes.sending_time_font}>
                                            {data.sendingTime}
                                        </Typography>
                                    </div>

                                </ListItem>
                            )}

                            {/* 定型文の場合 */}
                            {data.messageType === "4" && (
                                // 送信者が管理者なら緑
                                <ListItem alignItems="flex-start">
                                    <Paper
                                    className={classes.paper_centerCallout}
                                    elevation='2'>

                                        <ListItemText
                                            className={classes.listItemMargine}
                                            primary={
                                                <React.Fragment>
                                                    <Typography variant="body2" className={classes.template_message}>
                                                        {data.sendMessage}
                                                    </Typography>

                                                    <Typography variant="body2" className={classes.template_message}>
                                                        {data.sendingTime}
                                                    </Typography>
                                                </React.Fragment>
                                            }
                                        />
                                    </Paper>
                                </ListItem>
                            )}
                        </React.Fragment>

                    ))}
                </List>
                <div className={classes.loading_position}>
                    {this.isLoading === true ? <CircularProgress color="secondary" size="30px" /> : ""}
                </div>
                <div style={{ float: "left", clear: "both" }}
                    ref={(el) => { this.messagesEnd = el; }}>
                </div>
            </div>
        );
    }
}

MessageView.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withCookies(MessageView));